import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button as MuiButton } from "@mui/material";
import intl from "react-intl-universal";
import { Button } from "../../Atoms/Button";
import { PageAlertRenderer } from "../PageAlert";

export const ScreenGreeting = ({
  title,
  subTitle = "",
  hasButton = false,
  hasBackButton = false,
  imgProperties = "",
  imgUrl = "",
  buttonTitle = undefined,
  trailing = null,
  children = null,
  handleClick = () => { },
  handleBack = () => { },
}) => {
  return (
    <div className="mb-6 w-full min-w-0">
      <PageAlertRenderer priority={10} />
      {hasBackButton && (
        <MuiButton
          onClick={handleBack}
          startIcon={<ArrowBackIcon />}
          variant="text"
          className="!mb-2 !pl-0 !text-[#c09455] hover:!bg-brand-cream"
          sx={{ paddingLeft: 0, marginBottom: 1 }}
        >
          {intl.get("words.back")}
        </MuiButton>
      )}

      <div className="flex w-full min-w-0 flex-col items-start justify-between gap-3 xl:flex-row xl:items-center">
        <h1 className="min-w-0 w-full break-words text-xl font-bold text-brand-dark dark:text-gray-100 md:text-2xl">
          {title}
        </h1>

        {trailing ? (
          <div className="w-full min-w-0 xl:w-auto xl:shrink-0">{trailing}</div>
        ) : null}

        {hasButton && !trailing && (
          <div className="shrink-0">
            <Button className="extra-button" onClick={handleClick}>
              {buttonTitle}
            </Button>
          </div>
        )}
      </div>

      {subTitle && (
        <p className="mt-1 break-all text-xs text-gray-500 dark:text-gray-400 md:text-sm">{subTitle}</p>
      )}

      {children}

      {hasButton && trailing && (
        <div className="mt-3 shrink-0 sm:hidden">
          <Button className="extra-button" onClick={handleClick}>
            {buttonTitle}
          </Button>
        </div>
      )}
      {!!imgProperties && (
        <div>
          <img
            src={imgUrl}
            alt="qrCode"
            style={{ width: imgProperties.width, height: imgProperties.height }}
          />
        </div>
      )}
    </div>
  );
};

ScreenGreeting.propTypes = {};
